<template>
  <div class="latin-america-gdp bg--color-01">
    <div class="container-wrapper bg--color-10">
      <div class="latin-america-gdp__container container-new">
        <div class="latin-america-gdp__left-column">
          <span
            class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold"
          >
            {{ $t('latinAmerica.gdp.title') }}
          </span>

          <span class="txt txt--16px txt--height-20px txt--color-04">
            {{ $t('latinAmerica.gdp.subtitle') }}
          </span>

          <img
            class="latin-america-gdp__image mt-auto"
            width="100%"
            src="@/assets/img/latin-america/gdp.svg"
            alt="image"
          >
        </div>

        <div class="latin-america-gdp__right-column">
          <div class="latin-america-gdp__right-label txt txt--16px txt--height-20px txt--color-01">
            {{ $t('latinAmerica.gdp.rightLabel') }}
          </div>

          <div class="latin-america-gdp__items mt-10">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="latin-america-gdp__item bg--color-02"
            >
              <span
                class="txt txt--22px txt--height-30px txt--26px--m txt--height-34px--m txt--color-04 txt--bold"
              >
                {{ item.text }}
              </span>

              <span
                class="latin-america-gdp__percent txt txt--22px txt--height-30px txt--color-04 txt--bold bg--color-09"
              >
                {{ item.value }}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    items () {
      return [
        {
          // text: 'Latin America and the Caribbean',
          value: '1.2',
        },
        {
          // text: 'South America',
          value: '0.6',
        },
        {
          // text: 'Central America and Mexico',
          value: '2.0',
        },
        {
          // text: 'Central America',
          value: '3.1',
        },
        {
          // text: 'The Caribbean (excl, Guyana)',
          value: '3.5',
        },
      ].map((item, index) => ({
        ...item,
        text: this.$t(`latinAmerica.gdp.items.${index}`),
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.latin-america-gdp {
  &__left-column {
    display: flex;
    flex-direction: column;
    gap: toRem(18px);
  }

  &__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(24px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__image {
    max-width: toRem(300px);
    margin-left: auto;
    margin-right: auto;

    @include bp(m) {
      max-width: toRem(250px);
      margin-left: unset;
    }

    @include bp(l) {
      max-width: toRem(420px);
    }
  }

  &__right-label {
    width: fit-content;
    margin-left: auto;
    // max-width: toRem(80px);
    margin-right: toRem(12px);
    // text-align: center;

    @include bp(m) {
      margin-right: toRem(8px);
    }
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: toRem(16px);
  }

  &__percent {
    width: toRem(80px);
    height: toRem(80px);
    border-radius: toRem(20px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__item {
    display: grid;
    grid-template-columns: 1fr toRem(80px);
    align-items: center;
    gap: toRem(12px);
    padding: toRem(12px);
    border-radius: toRem(20px);

    @include bp(m) {
      gap: toRem(24px);
      border-radius: toRem(24px);
      padding: toRem(8px);
      padding-left: toRem(20px);
    }
  }
}
</style>
